/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TabsExampleContentOutside, TabsExampleContentObject, TabsExampleScrollable, TabsExampleLeftAligned, TabsExampleUsingData, TabsExampleHorizontallyAligned, TabsExampleMaxWidth, TabsExampleReachRouterNavigation, TabsNoBorder, TabsNoBreakout, TabsExamplePrerender, TabsSingleChildrenReactElement, TabsSingleElementData, TabsAlignProperty} from 'Docs/uilib/components/tabs/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code",
    strong: "strong",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components), {VisibleWhenVisualTest} = _components;
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Tabs where content is provided from outside"
    }), "\n", _jsx(_components.p, {
      children: "As this may be a more common use case, we still have to ensure our tabs content is linked together with the tabs – because of accessibility."
    }), "\n", _jsxs(_components.p, {
      children: ["You have to provide an ", _jsx(_components.code, {
        children: "id"
      }), " to both of the components."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "NB:"
      }), " You don't need to use a function inside ", _jsx(_components.code, {
        children: "Tabs.Content"
      }), " – it can contain any element you need, as long as it is a React Node."]
    }), "\n", _jsx(TabsExampleContentOutside, {}), "\n", _jsx(_components.h3, {
      children: "Tabs using 'data' property and content object"
    }), "\n", _jsx(TabsExampleContentObject, {}), "\n", _jsx(_components.h3, {
      children: "Tabs using 'data' property only"
    }), "\n", _jsx(TabsExampleUsingData, {}), "\n", _jsx(_components.h3, {
      children: "Tabs using React Components only"
    }), "\n", _jsxs(_components.p, {
      children: ["Also, this is an example of how to define a different content background color, by providing ", _jsx(_components.code, {
        children: "content_style"
      }), "."]
    }), "\n", _jsx(TabsExampleLeftAligned, {}), "\n", _jsx(_components.h3, {
      children: "Tabs without bottom border"
    }), "\n", _jsx(TabsNoBorder, {}), "\n", _jsx(_components.h3, {
      children: "Tabs without breakout"
    }), "\n", _jsx(TabsNoBreakout, {}), "\n", _jsxs(_components.h3, {
      children: ["Tabs and ", _jsx(_components.code, {
        children: "prerender"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["By using ", _jsx(_components.code, {
        children: "prerender={true}"
      }), " the content is kept inside the DOM."]
    }), "\n", _jsx(_components.p, {
      children: "Also, when switching the tabs, the height is animated."
    }), "\n", _jsx(TabsExamplePrerender, {}), "\n", _jsx(_components.h3, {
      children: "Tabs optimized for narrow screens"
    }), "\n", _jsx(_components.p, {
      children: "Navigation buttons will be shown and the tabs-list will be scrollable."
    }), "\n", _jsx(TabsExampleScrollable, {}), "\n", _jsx(_components.h3, {
      children: "Horizontal aligned tabs"
    }), "\n", _jsx(TabsExampleHorizontallyAligned, {}), "\n", _jsx(_components.h3, {
      children: "max-width usage"
    }), "\n", _jsx(TabsExampleMaxWidth, {}), "\n", _jsx(_components.h3, {
      children: "Router integration"
    }), "\n", _jsxs(_components.p, {
      children: ["This demo uses ", _jsx(_components.code, {
        children: "@reach/router"
      }), ". More ", _jsx(_components.a, {
        href: "https://codesandbox.io/embed/8z8xov7xyj",
        children: "examples on CodeSandbox"
      }), "."]
    }), "\n", _jsx(TabsExampleReachRouterNavigation, {}), "\n", _jsx(_components.h2, {
      children: "Example Content"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "const exampleContent = {\n  first: () => <H2>First</H2>,\n  second: () => <Input label=\"Label:\">Focus me with next Tab key</Input>,\n  third: () => (\n    <>\n      <p>Paragraph 1</p>\n      <p>Paragraph 2</p>\n    </>\n  ),\n  fourth: 'Fourth as a string only',\n}\n"
      })
    }), "\n", _jsxs(VisibleWhenVisualTest, {
      children: [_jsx(TabsSingleChildrenReactElement, {}), _jsx(TabsSingleElementData, {}), _jsx(TabsAlignProperty, {})]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
